import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Whatsapp from "../components/Whatsapp";
import banner1 from "../assets/images/contact.jpg";
import "../assets/css/font-awesome/all.min.css";
import "../assets/css/flaticon/flaticon.css";
import "../assets/css/owl-carousel/owl.carousel.min.css";
import "../assets/css/magnific-popup/magnific-popup.css";
import "../assets/css/style.css";

const Contact = () => {
  return (
    <div>
      <Navbar />
      <div className="project-banner" style={{
        backgroundImage: `url(${banner1})`, height: "650px",
        marginTop: "83px"
      }}></div>

      {/* contact section */}
      <section className="space-ptb contact-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="section-title" style={{ marginTop: "40px" }}>
                <h2>Contact Us</h2>
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-5">
              <div className="contact-address bg-light p-4">
                <div className="d-flex mb-3">
                  <div className="contact-address-icon">
                    <i className="flaticon-map text-black font-xlll"></i>
                  </div>
                  <div className="ms-3">
                    <h6>Address</h6>
                    <p><span>Devi vinayaka builders <br/>
                      Flat no.401, Gnanambhica
                      Residency, Door no.115-14-379, Airport Road, Beside of Sanitorium, Konthamuru Rajamahendravaram Rural.</span></p>
                  </div>
                </div>
                <div className="d-flex mb-3">
                  <div className="contact-address-icon">
                    <i className="flaticon-email text-black font-xlll"></i>
                  </div>
                  <div className="ms-3">
                    <h6>Email</h6>
                    <p>Devi Vinayaka Builders@gmail.com</p>
                  </div>
                </div>
                <div className="d-flex mb-3">
                  <div className="contact-address-icon">
                    <i className="flaticon-call text-black font-xlll"></i>
                  </div>
                  <div className="ms-3">
                    <h6>Phone Number</h6>
                    <p>8977060666</p>
                    <p>6305252452</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-7 mt-4 mt-lg-0">
              <div className="contact-form">
                <h4 className="mb-4" style={{ marginTop: "30px" }}>Enquire Now</h4>
                <form>
                  <div className="row">
                    <div className="mb-3 col-md-6">
                      <input type="text" className="form-control" placeholder="Your name" />
                    </div>
                    <div className="mb-3 col-md-6">
                      <input type="email" className="form-control" placeholder="Your email" />
                    </div>
                    <div className="mb-3 col-md-6">
                      <input type="text" className="form-control" placeholder="Your phone" />
                    </div>
                    <div className="mb-3 col-md-6">
                      <input type="text" className="form-control" placeholder="Subject" />
                    </div>
                    <div className="mb-3 col-md-12">
                      <textarea className="form-control" rows="4" placeholder="Your message"></textarea>
                    </div>
                    <div className="col-md-3 text-start">
                      <button className="btn btn-success btn-md custom-btn"
                      >Send Message</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-map-section">
        <div className="container">
          <div className="section-title text-center" style={{ marginBottom: "28px" }}>
            <h2>Find Us</h2>
          </div>
          <div className="contact-map-wrapper">
            <iframe
              title="Devi Vinayaka Builders Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3625.928754887014!2d81.78954657492642!3d17.039568583789496!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a37a1b706069205%3A0xf85cd123b0ee1151!2sDEVI%20VINAYAKA%20BUILDERS%20D.G%20RAJ%20TOWERS!5e1!3m2!1sen!2sin!4v1789749000258!5m2!1sen!2sin"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>

      <Whatsapp />
      <Footer />
    </div>
  );
};

export default Contact;
